import { render, staticRenderFns } from "./VolunteerForm.vue?vue&type=template&id=2ec8b36f&"
import script from "./VolunteerForm.vue?vue&type=script&lang=js&"
export * from "./VolunteerForm.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports